import { render } from "./BarcodeTargetField.vue?vue&type=template&id=0240436f&scoped=true"
import script from "./BarcodeTargetField.vue?vue&type=script&lang=js"
export * from "./BarcodeTargetField.vue?vue&type=script&lang=js"

import "./BarcodeTargetField.vue?vue&type=style&index=0&id=0240436f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0240436f"]])

export default __exports__